import { render, staticRenderFns } from "./PDFAnnotation.vue?vue&type=template&id=43fc5464&"
import script from "./PDFAnnotation.vue?vue&type=script&lang=js&"
export * from "./PDFAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports